import React from "react";

import Modal from "../../../../components/main/modal";
import Modal2 from "../../../../components/main/modal2";
import FooterMain from "../../../../components/main/footer";

interface Props {
	hide: boolean;
}

const Footer: React.FC<Props> = ({ hide = false }) => {
	return (
		<>
			<FooterMain />
			<Modal />
			<Modal2 />
		</>
	);
};

export default Footer;
